module.exports = __webpack_public_path__ + "img/stock5.c8fa2ae3.png";